import { results } from "./results"

export const RESULT_IDS = results.map((d) => d.resultId).sort((a, b) => a - b)

export const RESULTS_RENDER_DATA = [
  {
    resultId: 0,
    Result: "",
    Link: "",
    Price: "",
    Retailer: "",
    Category: "",
    Description: "",
    ImageURL: "",
  },
]

export const LAST_QUESTION_ID = 11
